import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import Header from "../components/Login_Header";
import { ApiError } from "../lib/api";
import {
  isValidMobile,
  loginWithPassword,
  sendLoginOtp,
  verifyLoginOtp,
} from "../lib/auth-api";
import { startSocialLogin } from "../lib/social-auth";
import "./Login.css";
// import Login_Header from "../components/Login_Header";

export default function Login() {
  const navigate = useNavigate();
  const [identifierType, setIdentifierType] = useState("mobile");
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [mode, setMode] = useState("password");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (identifierType === "mobile" && !isValidMobile(identifier)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (identifierType === "email" && !identifier.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      if (mode === "password") {
        await loginWithPassword(identifier, password);
        navigate("/delete-account");
      } else if (mode === "otp-request") {
        await sendLoginOtp(identifier);
        setMode("otp-verify");
      } else {
        await verifyLoginOtp(identifier, otp);
        navigate("/delete-account");
      }
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page">
      {/* <Login_Header /> */}
      <main className="login">
        <h1 className="login__title">Login to Delete Account</h1>

        <div
          className="login__toggle"
          role="radiogroup"
          aria-label="Login with"
        >
          <label
            className={`toggle-option ${identifierType === "mobile" ? "toggle-option--active" : ""}`}
          >
            <input
              type="radio"
              name="identifierType"
              checked={identifierType === "mobile"}
              onChange={() => {
                setIdentifierType("mobile");
                setIdentifier("");
                setError(null);
              }}
            />
            Mobile Number
          </label>
          <label
            className={`toggle-option ${identifierType === "email" ? "toggle-option--active" : ""}`}
          >
            <input
              type="radio"
              name="identifierType"
              checked={identifierType === "email"}
              onChange={() => {
                setIdentifierType("email");
                setIdentifier("");
                setError(null);
              }}
            />
            Email ID
          </label>
        </div>

        <form className="login__form" onSubmit={handleSubmit}>
          <label className="field">
            <span className="field__label">
              {identifierType === "mobile" ? "Mobile Number" : "Email ID"}
            </span>
            <input
              className="field__input"
              type={identifierType === "mobile" ? "tel" : "email"}
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder={
                identifierType === "mobile" ? "9876543210" : "you@example.com"
              }
              disabled={mode === "otp-verify"}
              required
            />
          </label>

          {mode === "password" && (
            <label className="field field--password">
              <input
                className="field__input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
              <button
                type="button"
                className="field__toggle-visibility"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </label>
          )}

          {mode === "otp-verify" && (
            <label className="field">
              <span className="field__label">Enter OTP</span>
              <input
                className="field__input"
                type="text"
                inputMode="numeric"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="6-digit code"
                required
              />
            </label>
          )}

          {mode === "password" && (
            <button
              type="button"
              className="login__link-button"
              onClick={() => {
                setError(null);
                setMode("otp-request");
              }}
            >
              Login with OTP
            </button>
          )}
          {mode !== "password" && (
            <button
              type="button"
              className="login__link-button"
              onClick={() => {
                setError(null);
                setOtp("");
                setMode("password");
              }}
            >
              Login with Password
            </button>
          )}

          {error && <p className="login__error">{error}</p>}

          <button type="submit" className="login__submit" disabled={loading}>
            {loading
              ? "Please wait…"
              : mode === "otp-request"
                ? "Send OTP"
                : mode === "otp-verify"
                  ? "Verify & Login"
                  : "Login"}
          </button>
        </form>

        <div className="login__divider">
          <span />
          <p>or Log in using</p>
          <span />
        </div>

        <div className="login__social">
          <button
            type="button"
            className="social-button"
            aria-label="Log in with Google"
            onClick={() => startSocialLogin("google")}
          >
            <GoogleIcon />
          </button>
          <button
            type="button"
            className="social-button"
            aria-label="Log in with Apple"
            onClick={() => startSocialLogin("apple")}
          >
            <AppleIcon />
          </button>
        </div>
      </main>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l6-6C34.6 5.1 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.4-.4-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.6 15.6 18.9 13 24 13c3.1 0 5.8 1.1 8 3l6-6C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 45c5.5 0 10.4-1.9 14.2-5.1l-6.6-5.6C29.5 36 26.9 37 24 37c-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.6 40.5 16.3 45 24 45z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4 5.7l6.6 5.6C41.1 36 44 30.5 44 24c0-1.2-.1-2.4-.4-3.5z"
      />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#000"
        d="M16.365 1.43c0 1.14-.396 2.2-1.05 3.02-.72.9-1.9 1.6-3.05 1.5-.13-1.1.42-2.24 1.08-2.96.73-.8 2.02-1.4 3.02-1.56zM20.5 17.2c-.55 1.28-.82 1.85-1.53 2.98-.98 1.57-2.36 3.53-4.07 3.55-1.52.02-1.91-.98-3.97-.97-2.06.01-2.5.99-4.02.97-1.71-.02-3.02-1.79-4-3.35C.4 17.35-.34 12.6 1.4 9.4c1.09-2 3.05-3.27 5.16-3.3 1.6-.03 3.1 1.08 4.07 1.08.97 0 2.79-1.33 4.7-1.14.8.03 3.06.32 4.51 2.44-.12.07-2.69 1.57-2.67 4.7.03 3.74 3.28 4.99 3.32 5.02z"
      />
    </svg>
  );
}
